import { SessionStorageService } from 'services';
import _ from 'lodash';
import { LoaderFunctionArgs } from 'react-router';

export const decodeState = (state: string) => JSON.parse(decodeURIComponent(String(state)));

export const googleCallbackLoader = ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  const code = url.searchParams.get('code');
  const state = url.searchParams.get('state');

  if (!state || !code) {
    window.opener.postMessage({ type: 'GOOGLE_OAUTH_ERROR' }, window.location.origin);

    SessionStorageService.remove('googleOAuthSalt');
    window.close();
    return null;
  }

  const decodedState = decodeState(state);
  const storedSalt = SessionStorageService.get('googleOAuthSalt');

  if (_.isEmpty(decodedState) || decodedState.salt !== storedSalt) {
    window.opener.postMessage({ type: 'GOOGLE_OAUTH_ERROR' }, window.location.origin);
  } else {
    window.opener.postMessage({ type: 'GOOGLE_OAUTH_SUCCESS', code }, window.location.origin);
  }

  SessionStorageService.remove('googleOAuthSalt');
  window.close();
  return null;
};
